/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlAuth0Connection } from './ControlAuth0Connection';
import {
    ControlAuth0ConnectionFromJSON,
    ControlAuth0ConnectionFromJSONTyped,
    ControlAuth0ConnectionToJSON,
} from './ControlAuth0Connection';

/**
 * 
 * @export
 * @interface ControlSSOStartLoginRequest
 */
export interface ControlSSOStartLoginRequest {
    /**
     * 
     * @type {ControlAuth0Connection}
     * @memberof ControlSSOStartLoginRequest
     */
    connection: ControlAuth0Connection;
    /**
     * 
     * @type {string}
     * @memberof ControlSSOStartLoginRequest
     */
    jwt?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSSOStartLoginRequest
     */
    deeplink?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSSOStartLoginRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSSOStartLoginRequest
     */
    u?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSSOStartLoginRequest
     */
    origin?: string;
}

/**
 * Check if a given object implements the ControlSSOStartLoginRequest interface.
 */
export function instanceOfControlSSOStartLoginRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "connection" in value;

    return isInstance;
}

export function ControlSSOStartLoginRequestFromJSON(json: any): ControlSSOStartLoginRequest {
    return ControlSSOStartLoginRequestFromJSONTyped(json, false);
}

export function ControlSSOStartLoginRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSSOStartLoginRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'connection': ControlAuth0ConnectionFromJSON(json['connection']),
        'jwt': !exists(json, 'jwt') ? undefined : json['jwt'],
        'deeplink': !exists(json, 'deeplink') ? undefined : json['deeplink'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'u': !exists(json, 'u') ? undefined : json['u'],
        'origin': !exists(json, 'origin') ? undefined : json['origin'],
    };
}

export function ControlSSOStartLoginRequestToJSON(value?: ControlSSOStartLoginRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'connection': ControlAuth0ConnectionToJSON(value.connection),
        'jwt': value.jwt,
        'deeplink': value.deeplink,
        'email': value.email,
        'u': value.u,
        'origin': value.origin,
    };
}

